<h3 [innerHTML]="printDocumentText.heading"></h3>

<div [innerHTML]="printDocumentText.mainText" class="id37-text2 text-light"></div>

<app-print-button (buttonClicked)="printReport()"
                  [showFirefoxWarning]="true"
                  [text]="printDocumentText.printButtonText"></app-print-button>
